import * as Sentry from '@sentry/browser'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import { logger } from '@/utils/logger'

const getDb = () => {
  if (!firebase.apps.length) {
    throw new Error('Firebase not initialized')
  }
  return firebase.firestore()
}

const getRecentInviteId = (person) => person?.uid || person?.dayforceUserId || null

const normalizeRecentInvite = (person = {}) => ({
  name: person?.name || '',
  email: person?.email || null,
  uid: person?.uid || null,
  dayforceUserId: person?.dayforceUserId || null,
  isDayforceUser: Boolean(person?.isDayforceUser)
})

export async function addRecentInvite(currentUserUid, invitedPerson) {
  try {
    const db = getDb()
    const recentInvitesRef = db.collection('recentInvites').doc(currentUserUid)
    const recentInviteId = getRecentInviteId(invitedPerson)
    if (!recentInviteId) {
      return
    }

    // Get current invites
    const doc = await recentInvitesRef.get()
    let invites = doc.exists ? doc.data().invites : []

    // Remove if person already exists
    invites = invites.filter((person) => getRecentInviteId(person) !== recentInviteId)

    // Add to beginning and keep only 3
    invites.unshift(normalizeRecentInvite(invitedPerson))

    if (invites.length > 3) {
      invites = invites.slice(0, 3)
    }

    // Save to Firestore
    await recentInvitesRef.set({ invites })
  } catch (error) {
    logger.error('Error adding recent invite:', error.message)
    Sentry?.captureException(error)
  }
}

export async function getRecentInvites(currentUserUid) {
  try {
    const db = getDb()
    const doc = await db.collection('recentInvites').doc(currentUserUid).get()
    if (!doc.exists) {
      return []
    }

    return (doc.data().invites || [])
      .map((person) => normalizeRecentInvite(person))
      .filter((person) => Boolean(getRecentInviteId(person)))
  } catch (error) {
    logger.error('Error getting recent invites:', error.message)
    Sentry?.captureException(error)
    return []
  }
}
